export const getFromLocalStorage = (key, defaultValue) => {
    if (defaultValue === undefined) {
        defaultValue = null;
    }
    try {
        return JSON.parse(localStorage.getItem(key)) || defaultValue;
    } catch (e) {
        return defaultValue;
    }
}

export const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
}


export const clearLocalStorageByPrefix = (prefix) => {
    for (let key in localStorage) {
        if (key.startsWith(prefix)) {
            localStorage.removeItem(key);
        }
    }
}
